import axios from 'axios'
import {
  GENDER_TYPE_ENUMS,
  MARITAL_STATUS_TYPE_ENUMS,
  RELATION_TYPE_ENUMS,
} from 'src/utils/constants/BuyPolicy'

const getGenderByType = (type) => {
  switch (type) {
    case RELATION_TYPE_ENUMS.FATHER:
    case RELATION_TYPE_ENUMS.FATHER_IN_LAW:
    case RELATION_TYPE_ENUMS.BROTHER:
    case RELATION_TYPE_ENUMS.SON:
    case RELATION_TYPE_ENUMS.STEPSON:
    case RELATION_TYPE_ENUMS.GRANDFATHER:
    case RELATION_TYPE_ENUMS.BROTHER_IN_LAW:
      return GENDER_TYPE_ENUMS.MALE
    case RELATION_TYPE_ENUMS.MOTHER:
    case RELATION_TYPE_ENUMS.MOTHER_IN_LAW:
    case RELATION_TYPE_ENUMS.SISTER:
    case RELATION_TYPE_ENUMS.SISTER_IN_LAW:
    case RELATION_TYPE_ENUMS.STEPDAUGHTER:
    case RELATION_TYPE_ENUMS.DAUGHTER:
    case RELATION_TYPE_ENUMS.GRANDMOTHER:
    case RELATION_TYPE_ENUMS.WIFE:
      return GENDER_TYPE_ENUMS.FEMALE
    default:
      return GENDER_TYPE_ENUMS.OTHERS
  }
}

const getMaritalStatusByRelationType = (type) => {
  switch (type) {
    case RELATION_TYPE_ENUMS.FATHER:
    case RELATION_TYPE_ENUMS.FATHER_IN_LAW:
    case RELATION_TYPE_ENUMS.MOTHER:
    case RELATION_TYPE_ENUMS.MOTHER_IN_LAW:
    case RELATION_TYPE_ENUMS.GRANDFATHER:
    case RELATION_TYPE_ENUMS.WIFE:
    case RELATION_TYPE_ENUMS.GRANDMOTHER:
      return MARITAL_STATUS_TYPE_ENUMS.married
    case RELATION_TYPE_ENUMS.BROTHER:
    case RELATION_TYPE_ENUMS.SON:
    case RELATION_TYPE_ENUMS.STEPSON:
    case RELATION_TYPE_ENUMS.SISTER:
    case RELATION_TYPE_ENUMS.STEPDAUGHTER:
    case RELATION_TYPE_ENUMS.DAUGHTER:
      return MARITAL_STATUS_TYPE_ENUMS.single
    default:
      return null
  }
}

const buyPolicyJourney = async (token, data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/enquiry`,
    data,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return response.data
}

export { getGenderByType, getMaritalStatusByRelationType, buyPolicyJourney }
